import { dashboard } from './dashboard'

export const home = {
  name: 'home',
  path: '/:pathMatch(.*)*',
  redirect: { name: dashboard.name }
}
